import Vue from 'vue';
import _ from 'lodash';


const success = (response, context, fromMessagesTab) => {
  if (fromMessagesTab) {
    context.notificationData = response.data.notificationData;
  } else {
    context.booking = response.data.booking;

    if (context.booking.payments) {
      Object.values(context.booking.payments).forEach((payment) => {
        payment.vat = payment.vat || context.booking.rental.vat;
        if (payment.type === 'service charge' || payment.type === 'taxes') { payment.vat = 0; }

        if (payment.imported) {
          if (payment.status && payment.paid_date) {
            payment.paymentStatus = 1;
          } else if (context.booking.status !== 0 && context.booking.payment_is_done === 1) {
            payment.paymentStatus = 1;
          } else {
            payment.paymentStatus = 0;
          }
        } else if (payment.status) {
          payment.paymentStatus = 1;
        } else {
          payment.paymentStatus = 0;
        }
      });

      const bookingPayments = _.cloneDeep(response.data.booking.payments);
      const hostFeeIndex = response.data.booking.payments.findIndex(p => (p.type === 'hostFee'));
      if (hostFeeIndex >= 0) {
        bookingPayments[hostFeeIndex].type = 'Host service fee';
      }

      context.hostPayoutFee = bookingPayments;
      context.invoices = response.data.booking.payments;
    }

    context.guest = response.data.booking.guest;
    context.rental = response.data.booking.rental;
    context.payment.booking_id = response.data.booking.id;
    context.rentals = response.data.rentals;
    context.user = response.data.user;
    context.form = response.data.form;
    context.notificationData = response.data.notificationData;
    if (context.notificationData) {
      Object.values(context.notificationData).forEach((notification) => {
        if (notification.triggerTime) {
          notification.triggerTime = notification.triggerTime.split('-').join('/');
        }
      });
    }
    context.extra_form_data = response.data.booking.extra_data_from_form;
    if (context.booking.contract) {
      context.contract = context.booking.contract;
    } else if (context.rental.contract) {
      context.contract = context.rental.contract.content;
    } else {
      context.contract = ' ';
    }

    if (response.data.booking.statusCode === 15) {
      context.deposit_status = 15;
    } else if (response.data.booking.statusCode === 14) {
      context.deposit_status = 14;
    }
    if ((response.data.booking.status === 1 || response.data.booking.status === 3) && response.data.booking.statusCode >= 12) {
      context.payment_status = 12;
    } else {
      context.payment_status = 10;
    }
    
    if (context.user.rights) {
      const rights = Object.values(context.user.rights);
      context.user.right = rights.find(item => item.parent_id == context.rental.user_id);
    }
    if (context.bookingResDetails !== undefined) {
      // console.log(response.data.booking.reservation_details);
      JSON.parse(response.data.booking.reservation_details, (resDataKey, resDataValue) => {
        context.bookingResDetails += resDataKey && `${resDataKey}=${resDataValue}\n\n`;
      });
      // context.bookingResDetails += `customer_id=${context.booking.customer_id ? context.booking.customer_id : '-'}`;
      context.bookingResDetails = context.bookingResDetails.trim();
      // console.log(context.bookingResDetails);
    }
  }
};

const failed = (error, context) => {
  context.loading = false;
  toastr.error(error);
  Vue.router.push({
    name: 'bookings.index',
  });
};

export default (id, context, fromMessagesTab = false) => Vue.$http.get(`/bookings/${id}`)
        .then((response) => {
          if (response.status === 200) {
            success(response, context, fromMessagesTab);
          } else {
            failed();
          }
        })
.catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/booking/getById.js